import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/linkedinimage.png";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I think that is true as I ve
              been working more than 17+ years 🤷‍♂️
              <br />
              <br />I also worked in classics like
              <i>
                <b className="purple"> .Net Web.Forms , Web.Services, C#. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="mobile:flex mobile:justify-center">
            <Tilt>
              <img
                src={myImg}
                className="rounded-full h-40 w-40"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/edilsonandrade"
                  target="_blank"
                  rel="noreferrer"
                  className="flex justify-center bg-white p-3 rounded-full"
                >
                  <AiFillGithub size={15} />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/edilson-augusto-de-andrade-3727759/"
                  rel="noreferrer"
                  className="flex justify-center bg-white p-3 rounded-full"
                >
                  <FaLinkedinIn size={15} />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
